import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ExportsState } from './exports.state';

export const EXPORTS_FEATURE_KEY = 'Exports';

export const selectExportsState = createFeatureSelector<ExportsState>(EXPORTS_FEATURE_KEY);

export const selectUserExports = createSelector(selectExportsState, (state) => state.exports);
export const selectIsExportsStateLoaded = createSelector(selectExportsState, (state) => state.isLoaded);
